module.exports = __webpack_public_path__ + "static/media/burrito.8e01eea6.jpeg";